import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { alpha, keyframes, useTheme } from "@mui/material/styles";
import { LOGO_HEIGHTS, logoImageSx } from "@/components/brand/logoImageSx";
const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.85; transform: scale(0.96); }
`;
const sizeMap = {
  inline: { logo: 0, spinner: 14, gap: 0.5, showLogo: false },
  sm: { logo: 26, spinner: 20, gap: 1, showLogo: false },
  md: { logo: 44, spinner: 28, gap: 1.5, showLogo: true },
  lg: { logo: 64, spinner: 36, gap: 2, showLogo: true },
};
const variantMap = {
  inline: sizeMap.inline,
  component: sizeMap.md,
  route: sizeMap.md,
  page: sizeMap.lg,
};
function BrandLoader({
  variant = "component",
  label = "Loading workspace\u2026",
  overlay = false,
  testId = "brand-loader",
}) {
  const theme = useTheme();
  const dims = variantMap[variant] ?? sizeMap.md;
  const fullPage = variant === "page" || variant === "route";
  return (
    <Stack
      data-testid={testId}
      alignItems="center"
      justifyContent="center"
      spacing={dims.gap}
      role="status"
      aria-live="polite"
      aria-label={label}
      className="brand-loader-root"
      sx={{
        width: fullPage ? "100%" : "auto",
        minHeight: overlay
          ? void 0
          : fullPage
            ? variant === "page"
              ? "100vh"
              : variant === "route"
                ? "60vh"
                : "40vh"
            : variant === "component"
              ? 160
              : "auto",
        py: overlay ? 2 : fullPage ? 4 : variant === "inline" ? 0 : 2,
        px: overlay ? 2 : 0,
        ...(overlay
          ? {
              position: "absolute",
              inset: 0,
              zIndex: 2,
              bgcolor: alpha(theme.palette.background.default, 0.88),
              backdropFilter: "blur(4px)",
            }
          : {}),
      }}
    >
      {dims.showLogo && (
        <Box
          component="img"
          src="/logo-main.png"
          alt="GPS WALA"
          className="erp-brand-logo-img"
          sx={{
            ...logoImageSx(dims.logo || LOGO_HEIGHTS.md),
            animation: `${pulse} 1.6s ease-in-out infinite`,
          }}
        />
      )}
      <CircularProgress
        size={dims.spinner}
        thickness={4}
        sx={{ color: "primary.main" }}
      />
      {label && dims.showLogo && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontWeight: 600, mt: 0.5 }}
        >
          {label}
        </Typography>
      )}
    </Stack>
  );
}
export { BrandLoader };
